import { createSelector } from '@reduxjs/toolkit';

export const selectLocationConfig = createSelector(
  [(state) => state.pageConfig.location as Location],
  (data) => data,
);
